<app-msg></app-msg>
<header>
  <div>
    <div [routerLink]="['']" class="btn back-button">
      <svg fill="#FFFFFF" height="30px" viewBox="0 -960 960 960" width="24px" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z" />
      </svg>
    </div>
    <h1 class="title">Customo</h1>
    <br>
  </div>
</header>

<div class="container">
  <router-outlet />
</div>
<footer>Created by <a href="https://thomasmalicet.com/" target="_blank">Thomas</a></footer>
